"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../config/types");
const offchainCollateral_1 = __importDefault(require("./offchainCollateral"));
const offchainBorrowable_1 = __importDefault(require("./offchainBorrowable"));
const farms_1 = require("../../config/farms");
const utils_1 = require("../../utils");
const amms_1 = require("../../config/amms");
const factories_1 = require("../../config/factories");
class OffchainLendingPool {
    constructor(offchain, factory, pairAddress) {
        this.getOffchain = () => this.offchain;
        this.getFactory = () => this.factory;
        this.getPairAddress = () => this.pairAddress;
        // Shortcuts
        this.getBorrowableA = () => this.poolTokens[types_1.PoolTokenType.BorrowableA];
        this.getBorrowableB = () => this.poolTokens[types_1.PoolTokenType.BorrowableB];
        this.getCollateral = () => this.poolTokens[types_1.PoolTokenType.Collateral];
        this.offchain = offchain;
        this.factory = factory;
        this.pairAddress = pairAddress;
        this.poolTokens = {
            [types_1.PoolTokenType.Collateral]: new offchainCollateral_1.default(this),
            [types_1.PoolTokenType.BorrowableA]: new offchainBorrowable_1.default(this, types_1.PoolTokenType.BorrowableA),
            [types_1.PoolTokenType.BorrowableB]: new offchainBorrowable_1.default(this, types_1.PoolTokenType.BorrowableB),
        };
    }
    getPoolToken(poolTokenType) {
        return this.poolTokens[poolTokenType];
    }
    // Offchain calls
    getLendingPoolData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.offchain.getLendingPoolData(this.factory, this.pairAddress);
        });
    }
    // Whitelist State
    getWhitelistState() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.offchain.getWhitelistState(this.factory, this.pairAddress);
        });
    }
    // Safety Margin
    getSafetyMargin() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return parseFloat(lendingPoolData[types_1.PoolTokenType.Collateral].safetyMargin);
        });
    }
    // Liquidation Penalty
    getLiquidationIncentive() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return parseFloat(lendingPoolData[types_1.PoolTokenType.Collateral].liquidationIncentive);
        });
    }
    getLiquidationFee() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            const liquidationFee = lendingPoolData[types_1.PoolTokenType.Collateral].liquidationFee;
            return liquidationFee ? parseFloat(liquidationFee) : 0;
        });
    }
    getLiquidationPenalty() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getLiquidationIncentive()) + (yield this.getLiquidationFee());
        });
    }
    // Uniswap APR
    getUniswapAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return lendingPoolData.pair.uniswapAPR;
        });
    }
    // Staking
    isStakedLPToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return lendingPoolData.pair.isStakedLPToken;
        });
    }
    getStakedLPExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return parseFloat(lendingPoolData.pair.exchangeRate);
        });
    }
    getStakingRewards() {
        return __awaiter(this, void 0, void 0, function* () {
            const farm = yield this.getFarm();
            const lendingPoolData = yield this.getLendingPoolData();
            if (farm === farms_1.Farms.solidex || farm === farms_1.Farms.solidexB || farm === farms_1.Farms.solidexUSDC || farm === farms_1.Farms.solidexUSDCB) {
                const solidexLPDetails = yield this.offchain.getSolidexHelper().getSolidexLPDetails();
                const result = solidexLPDetails[lendingPoolData.pair.uniswapV2PairAddress];
                if (result)
                    return result;
            }
            const FINISH_DELAY = 3600 * 24 * 1;
            const rewards = [];
            const stakedTotalSupply = parseFloat(lendingPoolData.pair.stakedTotalSupply);
            const underlyingLPPrice = yield this.getUnderlyingLPPrice(true);
            for (const reward of lendingPoolData.pair.rewards) {
                const multiplier = farm === farms_1.Farms.traderJoeV2 ? 0.5 : 1;
                const periodFinish = parseInt(reward.periodFinish);
                if ((new Date).getTime() / 1000 - FINISH_DELAY > periodFinish && periodFinish !== 0)
                    continue;
                let rewardRate = parseFloat(reward.rewardRate);
                if (farm == farms_1.Farms.traderJoeV4)
                    rewardRate = rewardRate * 0.45;
                const rewardPrice = yield this.offchain.getPriceHelper().getDebankTokenPrice(reward.rewardsToken.id);
                rewards.push({
                    APR: (0, utils_1.toAPR)((rewardPrice * rewardRate) / (stakedTotalSupply * underlyingLPPrice) * multiplier),
                    symbol: reward.rewardsToken.symbol,
                });
            }
            return rewards;
        });
    }
    getStakingAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const rewards = yield this.getStakingRewards();
            let APR = 0;
            for (const reward of rewards) {
                APR += reward.APR;
            }
            return APR;
        });
    }
    //Shown Leverage
    getShownLeverage() {
        return __awaiter(this, void 0, void 0, function* () {
            const safetyMargin = yield this.getSafetyMargin();
            if (safetyMargin < 1.25)
                return 20;
            if (safetyMargin < 1.51)
                return 10;
            if (safetyMargin < 2.01)
                return 5;
            return 3;
        });
    }
    // Past Data
    getLendingPoolDataPast24h() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getLendingPoolData()).past24h;
        });
    }
    getLendingPoolDataPast7d() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getLendingPoolData()).past7d;
        });
    }
    // Amms and farms
    getAmm() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return (0, amms_1.getAmmByFactory)(this.offchain.network, lendingPoolData.pair.uniswapV2Factory);
        });
    }
    getFarm() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return (0, farms_1.getFarmByStakedLPFactory)(this.offchain.network, lendingPoolData.pair.factory);
        });
    }
    // getCollateralPrice -> returns the price of the collateral, not necessarily of the underlying LP
    calculateCollateralPrice(reserve0, reserve1, totalSupply, price0, price1) {
        if (totalSupply === 0)
            return 0;
        const reserve0USD = reserve0 * price0;
        const reserve1USD = reserve1 * price1;
        // adjust reserves taking the latest price passed as parameters
        const adjustedReserveUSD = Math.sqrt(reserve0USD * reserve1USD) * 2;
        return adjustedReserveUSD / totalSupply;
    }
    getCollateralPrice(fast = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.getLendingPoolData();
            return this.calculateCollateralPrice(parseFloat(lendingPoolData.pair.reserve0), parseFloat(lendingPoolData.pair.reserve1), parseFloat(lendingPoolData.pair.totalSupply), fast ?
                yield this.getBorrowableA().getTokenPriceFast() :
                yield this.getBorrowableA().getTokenPriceAccurate(), fast ?
                yield this.getBorrowableB().getTokenPriceFast() :
                yield this.getBorrowableB().getTokenPriceAccurate());
        });
    }
    getUnderlyingLPPrice(fast = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.getCollateralPrice(fast)) / (yield this.getStakedLPExchangeRate());
        });
    }
    // Kink Multiplier
    getKinkMultiplier() {
        if (factories_1.OLD_KINK_MULTIPLIER_FACTORIES.includes(this.factory))
            return 5;
        return 2;
    }
    // Stats
    getTotalBorrowsUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const totalBorrowsUSDA = yield this.getBorrowableA().getTotalBorrowsUSD();
            const totalBorrowsUSDB = yield this.getBorrowableB().getTotalBorrowsUSD();
            return totalBorrowsUSDA + totalBorrowsUSDB;
        });
    }
    getTotalAPR() {
        return __awaiter(this, void 0, void 0, function* () {
            const uniswapV2Pair = (yield this.getLendingPoolData()).pair.uniswapV2PairAddress;
            // If llama fails/apr is 0 we get the uniswapAPR and stakingAPR through subgraph
            const apr = yield this.offchain.getAPRHelper().getLlamaAPR(uniswapV2Pair, this.offchain.network);
            if (apr > 0)
                return apr;
            // Try shadow on Sonic network
            const selAmm = yield this.getAmm();
            if (this.offchain.network === types_1.Networks.Sonic && selAmm == amms_1.Amms.shadow) {
                const shadowAPR = yield this.offchain.getAPRHelper().getShadowAPR(uniswapV2Pair, this.offchain.network);
                if (shadowAPR > 0)
                    return shadowAPR;
            }
            else if (this.offchain.network == types_1.Networks.Linea && (selAmm == amms_1.Amms.nile || selAmm == amms_1.Amms.nileStable)) {
                const nileAPR = yield this.offchain.getAPRHelper().getNileAPR(uniswapV2Pair, this.offchain.network);
                if (nileAPR > 0)
                    return nileAPR;
            }
            const [uniswapAPR, stakingAPR] = yield Promise.all([this.getUniswapAPR(), this.getStakingAPR()]);
            return uniswapAPR + stakingAPR;
        });
    }
}
exports.default = OffchainLendingPool;
